import React from 'react'
import PropTypes from 'prop-types'
import StyleSheet from 'styles'

const styles = StyleSheet({
  buttonBar: {
    display: 'flex'
  }
}, {classNamePrefix: 'SegmentedControl-'})

function SegmentedControl(props) {
  const { active, onSelected } = props
  return (
    <div className={styles.buttonBar}>
      {
        React.Children.map(props.children, (segment) => {
          const { label } = segment.props
          return React.cloneElement(segment, {active: (active === label),  onSelected})
        })
      }
    </div>
  )
}

SegmentedControl.propTypes = {
  active: PropTypes.string,
  onSelected: PropTypes.func.isRequired,
}

export default SegmentedControl